import { FC } from 'app/FunctionalComponent'
import React from 'react'
import { ValidatedSubmitButton } from 'ui/components/common/validated-submit-button'
import { Debug } from 'ui/components/dev/Debug'
import { FormVertical } from 'ui/components/form/FormVertical'
import { FormVerticalLayout } from 'ui/components/form/FormVerticalLayout'
import { FormVerticalReadOnly } from 'ui/components/form/FormVerticalReadOnly'
import { FormVerticalTextInput } from 'ui/components/form/FormVerticalTextInput'
import { IFormData } from 'ui/components/form/IFormData'
import { t } from 'ui/components/i18n/i18n'
import { AlignRight } from 'ui/components/layout/alignRight/AlignRight'
import {
	accountingCodeCatalogEntryFormMetadata,
	IAccountingCodeCatalogEntryForm,
} from 'ui/forms/formAccountingCodeCatalogEntry'
import { validateForm } from 'ui/lib/validation/formValidator'
import { sosAccountingCodeCatalogEntry } from 'ui/state'

export const UpdateAccountingCodeCatalogEntryForm: FC = (props: {
	mode: 'add' | 'edit'
	form: IAccountingCodeCatalogEntryForm
}) => {
	const formData: IFormData<IAccountingCodeCatalogEntryForm> = {
		form: props.form,
		metadata: accountingCodeCatalogEntryFormMetadata,
		onUpdateForm:
			sosAccountingCodeCatalogEntry.updateAccountingCodeCatalogEntryForm,
		tPrefix: 'shared.accountingCodeCatalog.accountingCodeCatalogPageForm',
	}

	const validationResult = validateForm(formData.form, formData.metadata)

	return (
		<div>
			<Debug hide={true} label='form data' data={props.form} />
			<FormVertical>
				<FormVerticalLayout>
					{props.mode === 'edit' && (
						<FormVerticalReadOnly formData={formData} field='id' />
					)}
					<FormVerticalTextInput formData={formData} field='accountingCode' />
					<FormVerticalTextInput
						formData={formData}
						field='accountingCodeDescription'
					/>
				</FormVerticalLayout>
				<AlignRight>
					<ValidatedSubmitButton
						testId='submit-upsert-accounting-code-catalog-page'
						onClick={async () => {
							await sosAccountingCodeCatalogEntry.updateAccountingCodeCatalogEntry(
								'upsert',
							)
						}}
						isValid={validationResult.isValid}
					>
						{t(
							`shared.accountingCodeCatalog.${props.mode}AccountingCodeCatalogPage`,
						)}
					</ValidatedSubmitButton>
				</AlignRight>
			</FormVertical>
		</div>
	)
}
